import { render, staticRenderFns } from "./foundation.vue?vue&type=template&id=cc8136e4&"
import script from "./foundation.vue?vue&type=script&lang=js&"
export * from "./foundation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports